import type { ReactNode } from 'react'
import { cx } from '../utils/cx'

interface SubmissionModalProps {
  open?: boolean
  stripe?: ReactNode
  title?: ReactNode
  desc?: ReactNode
  children?: ReactNode
  actions?: ReactNode
  className?: string
}

export function SubmissionModal({ open, stripe, title, desc, children, actions, className }: SubmissionModalProps) {
  return (
    <div className={cx('st-submitted', open && 'open', className)}>
      <div className="st-sub-card">
        {stripe && <span className="big-tag">{stripe}</span>}
        {title && <h2>{title}</h2>}
        {desc && <p>{desc}</p>}
        {children}
        {actions && (
          <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>{actions}</div>
        )}
      </div>
    </div>
  )
}
